import { useQuery } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { partnershipValues } from 'Features/checkout/views/Checkout/consts'
import { CouponType } from 'Features/checkout/components/Coupon/Coupon'

type PartnerResponse = {
  data: {
    name: string
    trialDays: number
    coupon: CouponType
  }
}
const getPartnership = async (partner: string | null, accountId: number) => {
  return await request<PartnerResponse>({
    url: `accounts/${accountId}/partners/${partner || ''}`,
    method: 'GET',
  })
}

type QueryFnType = typeof getPartnership

export const useGetPartnership = (partner: string | null) => {
  const { accountId } = useUserStore()

  const {
    data: queryData,
    refetch,
    isFetching,
  } = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['getPartnership', partner],
    queryFn: () => getPartnership(partner, accountId),
    enabled: !!accountId && !!partner && partnershipValues.includes(partner),
  })

  const data = !queryData || queryData instanceof Error ? null : queryData.data

  return { data, refetch, isFetching }
}
